import { viandas2PostForm } from "../../../common/service/viandas2Client";

export const importarMenuExcel = (file, idProveedor) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("id_proveedor", idProveedor);
  return viandas2PostForm("/rrhh/importar-menu", formData);
};

export const importarMenuEmpresasExcel = (file, idProveedor) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("id_proveedor", idProveedor);
  return viandas2PostForm("/rrhh/importar-menu-empresas", formData);
};
